import { useTheme } from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { DOCUMENTS } from 'hubspot-prosemirror/prosemirror/editorCapabilities';
import { useReactNodeView } from '../utils/ReactNodeView';
import contentOutputs from '../editorCapabilities/ContentOutputTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentLinkView = () => {
  var _node$attrs, _editorConfig$DOCUMEN;
  const trellisTheme = useTheme();
  const {
    node,
    editorConfig
  } = useReactNodeView();
  const {
    displayText,
    documentName,
    tokenTag
  } = (_node$attrs = node === null || node === void 0 ? void 0 : node.attrs) !== null && _node$attrs !== void 0 ? _node$attrs : {};
  const outputType = editorConfig === null || editorConfig === void 0 || (_editorConfig$DOCUMEN = editorConfig[DOCUMENTS]) === null || _editorConfig$DOCUMEN === void 0 ? void 0 : _editorConfig$DOCUMEN.outputType;
  if (outputType !== contentOutputs.EDITABLE) {
    return /*#__PURE__*/_jsx("span", {
      "data-test-id": "ProseMirror__documents",
      children: /*#__PURE__*/_jsx("a", {
        href: tokenTag,
        target: "_blank",
        rel: "noreferrer",
        children: displayText || tokenTag
      })
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "draftPlugins.documents.mergeTag.tooltip"
    }),
    placement: "top",
    children: /*#__PURE__*/_jsx("span", {
      style: {
        blockSize: '20px',
        inlineSize: 'auto',
        padding: `${trellisTheme.space['100']} ${trellisTheme.space['200']}`,
        marginInline: trellisTheme.space['200'],
        backgroundColor: trellisTheme.color['fill-positive-subtle'],
        borderRadius: trellisTheme.borderRadius['100'],
        color: trellisTheme.color['fill-positive-default'],
        border: `${trellisTheme.borderWidth['100']} solid transparent`
      },
      "data-test-id": "ProseMirror__documents",
      children: displayText || documentName || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubspot-prosemirror.documents.unknownDeck"
      })
    })
  });
};
export default DocumentLinkView;
export const documentLinkViewUpdateFn = ({
  previousNode,
  node
}) => {
  if (previousNode.attrs.documentId !== node.attrs.documentId || previousNode.attrs.displayText !== node.attrs.displayText || previousNode.attrs.requireEmail !== node.attrs.requireEmail) {
    return false;
  }
  return true;
};